$(document).ready(function () {

//    $('.slider-main').slick({
//        arrows: false,
//        slidesToShow: 1,
//        slidesToScroll: 1,
//        dots: false,
//        centerPadding: 0,
//        centerMode: true,
//        infinite: true,
//        fade: true,
//        speed: 400,
//        adaptiveHeight: true
//    });
//
//    $('#carousel-2').slick({
//        arrows: true,
//        slidesToShow: 5,
//        dots: false,
//        centerPadding: 0,
//        centerMode: true,
//        infinite: true,
//        focusOnSelect: true,
//        speed: 400,
//        asNavFor: '.carousel',
////                respondTo: 'slide',
//        adaptiveHeight: true,
//        responsive: [
//            {
//                breakpoint: 981,
//                settings: {
//                    arrows: true,
//                    slidesToShow: 5
//                }
//            },
//            {
//                breakpoint: 745,
//                settings: {
//                    arrows: true,
//                    slidesToShow: 3
//                }
//            },
//            {
//                breakpoint: 541,
//                settings: {
//                    arrows: true,
//                    slidesToShow: 1
//                }
//            }
//            // You can unslick at a given breakpoint now by adding:
//            // settings: "unslick"
//            // instead of a settings object
//        ]
//    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
//        $('#slider').attr('data-background', $('#slider .slick-slide').eq(nextSlide).attr('data-id'));
//        setFullImgAfterLoad($('#slider'));
//    });
//
//    $('.carousel').on('init', function (event) {
//        $('#slider .item').addClass('show');
//    }).slick({
//        slidesToShow: 1,
//        slidesToScroll: 1,
//        arrows: true,
//        fade: true,
//        dots: false,
//        centerPadding: 0,
//        asNavFor: '#carousel-2',
//        adaptiveHeight: true,
//        respondTo: 'slide'
//    });

    // fix label if input not empty
    function labelFix() {
        $('.form-control').each(function () {

            $(this).on('keyup click', function () {

                var val = $(this).val();
                if (val != null && val.length > 0) {
                    $(this).parent().find('label').addClass('not-empty');
                } else {
                    $(this).parent().find('label').removeClass('not-empty');
                }

            });
        });
    }

    labelFix();

    // initialize tooltipster on text input elements
    $('#suggest_book .form-control').tooltipster({
        trigger: 'custom',
        onlyOne: false,
        position: 'top-right',
        offsetX: 13
    });

    // initialize validate plugin on the form
    $('#suggest_book').validate({
        errorPlacement: function (error, element) {
            $(element).tooltipster('update', $(error).text());
            $(element).tooltipster('show');
        },
        success: function (label, element) {
            $(element).tooltipster('hide');
        },
        rules: {
            name: {
                required: true,
                minlength: 3,
                maxlength: 100
            },
            title: {
                required: true,
                minlength: 3,
                maxlength: 100
            },
            message: {
                required: true,
                minlength: 3,
                maxlength: 1000
            }
        },
        messages: {
            name: {
                required: "Please specify your name",
                name: "Sorry, the name is too short (3 characters min and 100 characters max)"
            },
            title: {
                required: "Sorry, title cannot be empty",
                title: "Sorry, the title is too short (3 characters min and 100 characters max)"
            },
            message: {
                required: "Sorry, message cannot be empty",
                message: "Sorry, the title is too short (3 characters min and 1000 characters max)"
            }
        },
        submitHandler: function (form) { // for demo
            return false;
        }
    });

    $('.progress-bar').each(function () {
        var value = $(this).attr('aria-valuenow');
        $(this).parent().prev().find('span').html(value);
    });

    $('.countdown').each(function () {
        var dates = $(this).attr('data-date');
        var lastDate = new Date(dates);
        lastDate = new Date(Date.UTC(lastDate.getFullYear(), lastDate.getMonth(), lastDate.getDate(), lastDate.getHours(), lastDate.getMinutes(), 0));
        $(this).countdown({
            until: lastDate,
            format: 'DHMS',
            labels: ['years', 'months', 'weeks', 'days', 'hours', 'min', 'sec'],
            layout: '<ul>{d<}<li><span>{dl}</span><p>{dn}</p></li>{d>}{h<}<li><span>{hl}</span><p>{hn}</p></li>{h>}' +
                    '{m<}<li><span>{ml}</span><p>{mn}</p></li>{m>}{s<}<li><span>{sl}</span><p>{sn}</p></li>{s>}</ul>'
        }).on('update.countdown', function(event) {
            console.log(event);
        }).on('finish.countdown', function(event) {
            console.log('finish');
            console.log(event);
        });
    });
    var view,
            produrctList;
            
    $('.conteporary-view-btns button').on('click', function () {
        view = $(this).attr('data-view');
        $(this).parent().find('button').removeClass('active');
        $(this).addClass('active');
        produrctList = $('.projects-list');

        if (!produrctList.hasClass(view)) {
            produrctList.removeClass('list grid').addClass(view);
        }
    });

    if ($(window).width() < 768) {
        $('.projects-list').removeClass('list').addClass('grid');
    }

    var hash = location.hash.replace('#', '');

//    $('.project-filter span').on('click', function () {
//        var tab = $(this).attr('data-href');
//
//        $('.percent-done .animated-line').css('width', '0');
//        $('.project-filter span').removeClass('active');
//        $(this).addClass('active');
//
//        if (tab === 'all') {
//            $('.projects-item').addClass('choosen');
//        } else {
//            $('.projects-item').removeClass('choosen');
//
////            setTimeout(function () {
//                $('.projects-item[data-id="' + tab + '"]').addClass('choosen');
////            }, 1);
//        }
//
//        $('.percent-done').each(function (i) {
//            $(this).find('.animated-line').animate({width: parseInt($(this).find('.percent-value').html(), 10) + "%"}, 1000);
//        });
//    });
    
//    $('.project-status-visible button').on('click', function () {
//        var tab = $('.project-filter span.active').attr('data-href');
//        
//        var status = $('.project-status-visible .active').attr('data-status-id');
//        
//        var status = $('.project-platform-filter .active').attr('data-platform-id');
//
//    });
//    projects multiple filter
    $('.filter-group').on('click', function () {
        $(this).parent().find('.filter-group').removeClass('active');
        $(this).addClass('active');
        
        var tab = $('.project-filter span.active').attr('data-href');
        
        var status = $('.project-status-visible .active').attr('data-status-id');
        
        var platform = $('.project-platform-filter .active').attr('data-platform-id');
        
        $('.percent-done .animated-line').css('width', '0');

        $('.projects-item').removeClass('choosen');
        $('.projects-item[data-id*="'+tab+'"][data-status*="'+status+'"][data-platform*="'+platform+'"]').addClass('choosen');

        $('.percent-done').each(function (i) {
            $(this).find('.animated-line').animate({width: parseInt($(this).find('.percent-value').html(), 10) + "%"}, 1000);
        });
    });    

    $('.disabled').on('click', function (e) {
        e.preventDefault();
    });
    
    $('.notify-me').on('click', function(){
        $(this).parent().addClass('active');
    });
    
    $('.subscribe_form .cb-form-control[name=name]').on('keyup', function(){
        
        if($(this).val().length < 3 || $(this).val().length > 100){
            $(this).addClass('error');
            addTooltipler($(this), 'The name should contain from 3 to 30 characters');
        } else {
            destroyTooltipler($(this));
            $(this).removeClass('error').addClass('success');
//            $(this).next().attr('title', '');
        }      
    });

    /**
     * Открытие модального окна с описанием типа книги
     */
    $(document).on("click", ".js-show-book-type", function () {
        var $this = $(this);
        var bookType = $this.data("id");
        var $modal = $(".js-modal--book-types");

        $modal.find(".book-type").hide();
        $modal.find(".book-type--" + bookType).show();
        $modal.show();
    });
});